<div role="status">
  <div
    class="border border-gray-200 dark:border-gray-700 divide-y divide-gray-200 dark:divide-gray-700 shadow animate-pulse px-4">
    @for (_ of pulseItems(); track $index) {
      <div class="flex items-center justify-between py-4">
        <div>
          <div class="w-24 h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 mb-2.5"></div>
          <div class="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
        </div>
        <div class="w-12 h-2.5 bg-gray-300 rounded-full dark:bg-gray-700"></div>
      </div>
    }
  </div>
  <span class="sr-only">Loading...</span>
</div>
